// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const qa4 = {
  name: 'qa4',
  production: false,
  domain: 'https://www.qa4.thermofisher.com',
  services: {
    cloudReferrer: "https://test.apps.thermofisher.com/apps/dashboard/#/",
    cdcam: {
      reset_password: {
        request_email: 'https://www.qa4.thermofisher.com/api-gateway/identity/reset-password/email',
        request: 'https://www.qa4.thermofisher.com/api-gateway/identity/reset-password/'
      },
      recover_username: 'https://www.qa4.thermofisher.com/api-gateway/accounts/username/recovery',
      identity: {
        login: 'https://www.qa4.thermofisher.com/api-gateway/identity/registration/redirect/login',
        registration: 'https://www.qa4.thermofisher.com/identity/account/registration',
        federation: {
          enabled: true,
          find_federated: '/api-gateway/identity-authorization/identity/fed/findfederateduser'
        },
        liteRegCheck: "/identity/api/cip/v1/literegistered/",
        rpUrls:"/api-gateway/identity-authorization/identity/auth-services/rp/urls/",
        updatedNotificationLink: 'https://dev-identity.thermofisher.com/cdcam/accounts/updated/notification/',
      }
    }
  },
  adobe: {
    digitalData: '/etc/designs/lifetech/clientlibs/digitaldata.min.js',
    enabled: true,
    launch: 'ENe956028acf6f4129a803968d774515c2-development'
  },
  pages: {
    loginError: "/account-center/loginError.html?source=gigyajs-proxy",
    contact_us: '/us/en/home/technical-resources/contact-us.html',
    privacy_policy: '/us/en/home/global/privacy-policy.html',
    policy_freight: '/us/en/home/global/online-pricing-policy.html',
    terms_condition: '/us/en/home/global/terms-and-conditions.html',
    china: {
      contact_us: '/cn/zh/home/hotline-guideline.html',
      business_check: 'https://218.242.124.22:8082/businessCheck/verifKey.do?showType=extShow&serial=9031000020171215105412000002252469-SAIC_SHOW_310000-4028e4cb6493ac2c0164c34158830f04018&signData=MEUCIGaAKW51heNd3cUsvTfF7YfkQoSdAyn4cx1XhwWh1t7BAiEAj22lrLm+yIbfvVqeOKnPa+Pz7/e6ouAI9EC1cJRPHRs=',
      icp_registration_number: 'https://beian.miit.gov.cn/',
      license: '/cn/zh/home/global/licenses-cn.html'
    }
  },
  resources: {
    reCaptchaV3: {
      siteKey: '6LfEnt8ZAAAAAK2c7EMp83J6HpMTR6lOmnRiUj0e'
    },
    reCaptchaV2: {
      siteKey: '6LfvDM0ZAAAAAIlBg3xXaej7CAN-seW-W4iHN1pH'
    }
  },
  shared_static: {
    global: '/shared-static/scripts/global-variables.js'
  },
  accountCreationHidden: {
    clientIds: ["NoABOs_47ARXX1b9-B44Da6l"],
  },
};
